import type { ReactNode } from "react";

type DataTableEmptyProps = {
  columns: number;
  message?: ReactNode;
};

/**
 * データが 0 件のときに描画する空状態セル。
 * @param {DataTableEmptyProps} props columns / message
 * @return {JSX.Element} 空行
 */
export const DataTableEmpty = ({
  columns,
  message = "データがありません",
}: DataTableEmptyProps): JSX.Element => {
  return (
    <tbody>
      <tr>
        <td
          colSpan={columns}
          className="px-3 py-10 text-center text-base-content/50"
        >
          {message}
        </td>
      </tr>
    </tbody>
  );
};
